import React from 'react';

import { Flex, Group, Stack, Text } from '@mantine/core';
import { AgentIcon } from 'icons/AgentIcon';
import { OverviewCard } from 'pages/GuestSmartAssistant/GuestDashboard/OverviewTab/OverviewCard';
import { useTranslation } from 'react-i18next';
import { SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';
import { formatDate } from 'shared/utils/format';
import { SMART_ASSISTANT_TYPE_DATA, getModelItems } from 'shared/utils/smart-assistant';

interface InformationItem {
  label: string;
  value: React.ReactNode | string;
}

interface InformationOverviewProps {
  smartAssistant: SmartAssistant;
}

export function InformationOverview({ smartAssistant }: InformationOverviewProps) {
  const { t } = useTranslation();

  const infoItems: InformationItem[] = [];

  // Model
  const modelItem = getModelItems(true, smartAssistant.type === SmartAssistantType.PHONE).find(
    (item) => item.value === smartAssistant.model
  );
  if (modelItem) {
    infoItems.push({
      label: t('SMART_ASSISTANT.OVERVIEW_SECTION.INFORMATION.MODEL'),
      value: (
        <Flex direction="row" align="center" gap={5}>
          {modelItem.icon}
          <Text size="sm" fw={500}>
            {modelItem.label}
          </Text>
        </Flex>
      )
    });
  }

  // Created
  infoItems.push({
    label: t('SMART_ASSISTANT.OVERVIEW_SECTION.INFORMATION.CREATED'),
    value: formatDate(smartAssistant.createdAt)
  });

  // Type
  const typeItem = SMART_ASSISTANT_TYPE_DATA[smartAssistant.type];
  infoItems.push({
    label: t('SMART_ASSISTANT.OVERVIEW_SECTION.INFORMATION.TYPE'),
    value: (
      <Flex direction="row" align="center" gap={5}>
        {typeItem.icon(18)}
        <Text size="sm" fw={500}>
          {typeItem.title}
        </Text>
      </Flex>
    )
  });

  return (
    <OverviewCard title={t('SMART_ASSISTANT.OVERVIEW_SECTION.INFORMATION.TITLE')} icon={<AgentIcon />}>
      <Stack spacing="xs">
        {infoItems.map((item, index) => (
          <Group key={index} position="apart" spacing="lg">
            <Text size="sm" c="dimmed">
              {item.label}
            </Text>
            {typeof item.value === 'string' ? (
              <Text size="sm" fw={500}>
                {item.value}
              </Text>
            ) : (
              item.value
            )}
          </Group>
        ))}
      </Stack>
    </OverviewCard>
  );
}
